// BE GradeDerivation + toStoredGradeLevel 1:1 포팅. 저장 키(elementary1 등) 반환.
// schoolYear = month>=3 ? year : year-1; idx = schoolYear - birthYear - 6 (1=elementary1)
const ELEM = ['elementary1', 'elementary2', 'elementary3', 'elementary4', 'elementary5', 'elementary6']
const MIDDLE = ['middle1', 'middle2', 'middle3']

export function deriveGradeKey(isoDob: string, today: Date = new Date()): string | null {
  if (!isoDob) return null
  const birthYear = Number(isoDob.slice(0, 4))
  if (!Number.isFinite(birthYear)) return null
  const month = today.getMonth() + 1
  const schoolYear = month >= 3 ? today.getFullYear() : today.getFullYear() - 1
  const idx = schoolYear - birthYear - 6
  if (idx < 1) return 'preschool'
  if (idx <= 6) return ELEM[idx - 1]
  if (idx <= 9) return MIDDLE[idx - 7]
  return 'high' // 고1~고3 및 그 이상 cap
}
